import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChannelsService } from 'src/app/services/channels.service';

@Component({
    selector: 'app-user-recommendations',
    templateUrl: './user-recommendations.component.html',
    styleUrls: ['./user-recommendations.component.scss']
})
export class UserRecommendationsComponent implements OnInit {

    mediaList: any[];
    mediaList2: any[] = [{}, {}, {}, {}, {}, {}, {}];

    loaded: boolean = false;

    @Input() currentFocus = false;

    @Output() rowFocused = new EventEmitter<void>();

    constructor(
        private channelService: ChannelsService) {
    }

    ngOnInit(): void {
        this.channelService.userChannels().subscribe(res => {
            if (res) {
                this.mediaList = res.find(f => f.type === 'user-recommendations').media;
                this.mediaList2 = null;
            }
        });
    }

}
